import { gql } from '@apollo/client';

export * from './billingTerminatedVsTotalCounts.query.generated';

export const BILLING_TERMINATED_VS_TOTAL_COUNTS = gql`
  query billingTerminatedVsTotalCounts {
    terminatedSoftwareEscrows: softwareEscrows(status: terminated) {
      nodesCount
    }
    allSoftwareEscrows: softwareEscrows {
      nodesCount
    }
    removedBackups: backups(status: terminated) {
      nodesCount
    }
    allBackups: backups {
      nodesCount
    }
    allContinuityEscrows: continuityEscrows {
      nodesCount
    }
    terminatedContinuityEscrows: continuityEscrows(status: terminated) {
      nodesCount
    }
    allCustodianProfiles: custodianProfiles {
      nodesCount
    }
    terminatedCustodianProfiles: custodianProfiles(status: terminated) {
      nodesCount
    }
    allSaasEscrows: saasEscrows {
      nodesCount
    }
    terminatedSaasEscrows: saasEscrows(status: terminated) {
      nodesCount
    }
  }
`;
